import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormGroup, UntypedFormBuilder, Validators} from "@angular/forms";
import {Subscription} from "rxjs";
import {indexNoValidator, phoneNumberValidator} from "../../../../Modules/Shared/UtilityClass/CustomValidators";
import {LipaService} from "../../../../Modules/beneficiary/Modules/lipa/Services/lipa.service";
import {SubmitBenefAdvancedSearchReq} from "../../Models/Requests/SubmitBenefAdvancedSearchReq";
import {BenefAdvancedSearchModel} from "../../Models/BenefAdvancedSearchModel";
import {CustomSwal} from "../../../../Modules/Shared/Services/CustomSwal";
import {HttpErrorResponse} from "@angular/common/http";
import {Institutions} from "../../../../Modules/beneficiary/Modules/lipa/Models/Institutions";

@Component({
  selector: 'app-benef-advanced-search',
  templateUrl: './benef-advanced-search.component.html',
  styleUrls: ['./benef-advanced-search.component.scss']
})
export class BenefAdvancedSearchComponent implements OnInit, OnDestroy {
  advancedSearchForm: FormGroup;
  loadingSubmit: boolean;
  savedAdvancedSearchDetails: BenefAdvancedSearchModel;
  private subscriptions: Subscription[] = [];
  year: number = new Date().getFullYear();
  institutions: Institutions[] = [];

  get f() {
    return this.advancedSearchForm?.controls;
  }

  constructor(
    private formBuilder: UntypedFormBuilder,
    private lipaService: LipaService,
  ) {
  }

  ngOnInit(): void {
    this.advancedSearchForm = this.formBuilder.group({
      benefIndexNo: ['', [indexNoValidator()]],
      firstName: ['', Validators.required],
      middleName: ['',],
      lastName: ['', Validators.required],
      sex: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, phoneNumberValidator()]],
      university: ['', Validators.required],
      startYear: ['', Validators.required],
      completionYear: ['', Validators.required],
    });

    this.getAllInstitutions();
  }

  onSubmit(value) {
    this.savedAdvancedSearchDetails = null;
    const req: SubmitBenefAdvancedSearchReq = new SubmitBenefAdvancedSearchReq();
    req.benef_index_no = value.benefIndexNo;
    req.first_name = value.firstName?.toUpperCase();
    req.middle_name = value.middleName?.toUpperCase();
    req.last_name = value.lastName?.toUpperCase();
    req.sex = value.sex;
    req.email = value.email;
    req.phone_number = value.phone;
    req.university_of_study = value.university;
    req.university_start_year = value.startYear;
    req.university_completion_year = value.completionYear;

    this.loadingSubmit = true;
    this.subscriptions.push(this.lipaService.submitBenefAdvancedSearchDetails(req).subscribe(
      {
        next: (response: BenefAdvancedSearchModel) => {
          this.loadingSubmit = false;
          CustomSwal.toastSuccess(`Successfully Saved Advanced Search Details With  Reference Number ${response?.reference_number}`);
          this.savedAdvancedSearchDetails = response;
        },
        error: (error: HttpErrorResponse) => {
          this.loadingSubmit = false;
          CustomSwal.toastFailed(error.error.detail);
        }
      }
    ))
  }

  getAllInstitutions() {
    this.subscriptions.push(this.lipaService?.getAllInstitutions().subscribe({
      next: (response: Institutions[]) => {
        this.institutions = response;
      },
      error: (error: HttpErrorResponse) => {
        CustomSwal.toastFailed(error.error.message);
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
